// extracted by mini-css-extract-plugin
module.exports = {"permission_item":"RolesDetails_permission_item__2WneO"};